import {FormEvent, useState} from "react";
import {Alert, Card, Form} from "react-bootstrap";
import {Link, useSearchParams} from "react-router";
import {UsersApi} from "../api/UsersApi";
import {ErrorAlert} from "../components/ErrorAlert";
import {SubmitButton} from "../components/SubmitButton";
import {MIN_PASSWORD_LENGTH, newPasswordProblem} from "../components/format";

// Opened from the "forgot password" email: /reset-password?token=…
export function ResetPasswordPage() {
    const [params] = useSearchParams();
    const token = params.get('token') ?? '';
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [validated, setValidated] = useState(false);
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState<unknown>();
    const problem = newPasswordProblem(password, confirm);

    const submit = async (e: FormEvent) => {
        e.preventDefault();
        setValidated(true);
        if (problem) {
            return;
        }
        setBusy(true);
        setError(undefined);
        try {
            await UsersApi.resetForgottenPassword(token, password);
            setDone(true);
        } catch (err) {
            setError(err);
        } finally {
            setBusy(false);
        }
    };

    return (
        <Card className="auth-card mx-auto mt-md-4">
            <Card.Body className="p-4">
                <h1 className="h4 mb-3">Choose a new password</h1>
                {!token ? (
                    <Alert variant="warning">This page needs the link from the email. <Link to="/forgot-password">Request a new one</Link>.</Alert>
                ) : done ? (
                    <Alert variant="success">Your password has been changed. <Link to="/login">Sign in</Link>.</Alert>
                ) : (
                    <>
                        <ErrorAlert error={error} messages={{ 404: 'This link has expired or was already used. Request a new one.' }}/>
                        <Form noValidate onSubmit={submit}>
                            <Form.Group className="mb-3" controlId="new-password">
                                <Form.Label>New password</Form.Label>
                                <Form.Control type="password" autoComplete="new-password" autoFocus value={password} onChange={e => setPassword(e.target.value)}
                                              isInvalid={validated && password.length < MIN_PASSWORD_LENGTH}/>
                                <Form.Text>At least {MIN_PASSWORD_LENGTH} characters.</Form.Text>
                            </Form.Group>
                            <Form.Group className="mb-4" controlId="confirm-password">
                                <Form.Label>Confirm new password</Form.Label>
                                <Form.Control type="password" autoComplete="new-password" value={confirm} onChange={e => setConfirm(e.target.value)}
                                              isInvalid={validated && !!problem}/>
                                <Form.Control.Feedback type="invalid">{problem}</Form.Control.Feedback>
                            </Form.Group>
                            <SubmitButton busy={busy} className="w-100">Change password</SubmitButton>
                        </Form>
                        <div className="text-center mt-3">
                            <Link to="/forgot-password" className="small">Request a new link</Link>
                        </div>
                    </>
                )}
            </Card.Body>
        </Card>
    );
}
